import {apiLandsRequests} from '#/repository/api-lands-requests';
import {Land} from '@shareland/shareland-common';
import {useQuery} from '@tanstack/react-query';

export const useLandTransactionsAmountMarketData = (land: Land | undefined) =>
  useQuery({
    queryKey: ['land-transactions-amount-market-data', land!.tokenSymbol],
    queryFn: () =>
      apiLandsRequests.getLandTransactionsAmountMarketData({
        land_token_symbol: land!.tokenSymbol,
      }),
    enabled: !!land,
  });
